// подключение scss
import './src/scss/entry.scss';

// подключение скриптов
let jsReq = require.context("/src/js", true, /\.js$/);
jsReq.keys().forEach(function (key) {
  jsReq(key);
});

// подключение svg
const svgReq = require.context('/src/images/icons/', true, /\.svg$/);
const paths = svgReq.keys();
paths.map(path => svgReq(path));
